import { render, staticRenderFns } from "./airdropLog.vue?vue&type=template&id=6e09a137&scoped=true&"
import script from "./airdropLog.vue?vue&type=script&lang=js&"
export * from "./airdropLog.vue?vue&type=script&lang=js&"
import style0 from "./airdropLog.vue?vue&type=style&index=0&id=6e09a137&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e09a137",
  null
  
)

export default component.exports